import columns from '../../react-table/helpers/columns';

export default (data) => {
  const {
    FilteredTextColumn,
    FilteredDateColumn,
    FilteredDateTimeWithSecondsColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new FilteredTextColumn('IMPC', 'impcCode'),
        new FilteredDateColumn('Calculate From', 'calculateFrom'),
        new FilteredTextColumn('Status', 'status'),
        new FilteredTextColumn('Created By', 'creationUser'),
        new FilteredDateTimeWithSecondsColumn('Creation Date', 'creationDate'),
        new FilteredTextColumn('Last Updated By', 'lastUpdateUser'),
        new FilteredDateTimeWithSecondsColumn('Last Update Date', 'lastUpdateDate'),
      ],
    },
  ];
};
